/* eslint-disable import/no-unresolved */
import React, { useContext } from 'react';
import { SwiperSlide } from 'swiper/react';
import Slider from './Slider';
import { CheckoutContext } from '../context/checkout';
import { formatPrice } from '../utils/formatPrice';
import { useRouter } from 'next/router';
import EventCard from './EventCard';

function DateSelect({ trip }) {
  const router = useRouter();
  const { setEvent } = useContext(CheckoutContext);
  return (
    <div className="relative mt-12 justify-self-end rounded-xl border-0 border-solid border-dark-100 lg:w-full lg:max-w-[27.75rem] lg:border-[1px] lg:p-8">
      <div className="hidden text-dark-800 lg:block">
        <span className="font-poppins lg:text-[22px] font-semibold leading-[25.2px] text-dark-800">
          {formatPrice(trip?.attributes?.display_price)}
        </span>
        <span className="font-sans text-base font-normal leading-[22.4px]"> / person</span>
      </div>
      <div className="hidden flex-col divide-y divide-dark-100 pt-3 lg:flex lg:divide-dark-50">
        {trip?.attributes?.events.map((item) => (
          <div key={item.id} className="lg:first:pt-0' bg-white px-6 py-6 lg:px-0">
            <EventCard
              event={item}
              onSelect={() => {
                setEvent(item);
                router.push({
                  pathname: `/trips/${trip?.attributes?.slug}/checkout`,
                  query: {
                    event_id: item.id,
                  },
                });
              }}
            />
          </div>
        ))}
      </div>
      <Slider
        slidesPerView="auto"
        spaceBetween={10}
        title="Upcoming dates"
        className="block lg:hidden"
      >
        {trip?.attributes?.events.map((event) => (
          <SwiperSlide key={event.id}>
            <div className=" w-[230px] rounded-xl border-[1px] border-solid border-dark-100 px-6 py-6 lg:rounded-none lg:border-x-0 lg:border-t-0 lg:border-b-[1px] lg:border-dark-50 lg:px-0 lg:first:pt-0 lg:last:border-0 lg:last:pb-0">
              <EventCard
                trip={trip}
                event={event}
                onSelect={() => {
                  setEvent(event);
                  router.push({
                    pathname: `/trips/${trip?.attributes?.slug}/checkout`,
                    query: {
                      event_id: event.id,
                    },
                  });
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Slider>
    </div>
  );
}

export default DateSelect;
